<template>
  <div>
    <collapse :value="!hasUsers">
      <h4>
        <b>{{ $t('cms.colleagues.NoColleagueFound') }}</b>
      </h4>
    </collapse>

    <collapse
      v-for="(user, index) in users"
      flexible-height
      :value="!user.isDeleted"
      :key="1 + user.id"
    >
      <div class="flex row my2 justify_between">
        <div class="flex">
          <icon
            trash
            small
            class="mya horizontal-transition"
            :class="usersToDelete.includes(user.id) ? 'mr2' : 'collapsed'"
            @click="confirmDeleteUser(user.id)"
          />

          <div
            class="online_status"
            :style="`background-color: ${getOnlineStatusColor(user.isOnline)}`"
          />

          <img :src="user.image.url" class="thumbnail"/>

          <span class="mya px2">
            <b>
              {{ user.fullName }}
            </b>
          </span>
        </div>

        <icon
          class="mya"
          cross
          v-if="isAdmin && !usersToDelete.includes(user.id)"
          @click="usersToDelete.push(user.id)"
        />
        <icon
          class="mya"
          cancel
          v-if="usersToDelete.includes(user.id)"
          @click="usersToDelete.splice(usersToDelete.indexOf(user.id), 1)"
        />
      </div>

      <hr
        v-if="users.length - 1 !== index"
        style="margin: 0; margin-top: -1px"
      />
    </collapse>
  </div>
</template>

<script>
import get from 'lodash/get';
import store from '@/store';

export default {
  name: 'colleagues',

  data() {
    return {
      fetchedUsers: [],
      usersToDelete: [],
      deletedUsers: [],
    };
  },

  created() {
    this.updateUsers();
  },

  computed: {
    users() {
      return this.fetchedUsers

        // filter current user
        .filter(({ id }) => id !== store.state.user.id)

        // add isDeleted property
        .map(user => Object.assign(user, { isDeleted: this.deletedUsers.includes(user.id) }));
    },

    hasUsers() {
      return this.users.filter(({ isDeleted }) => !isDeleted).length !== 0;
    },

    isAdmin() {
      return store.state.user.isAdmin;
    },
  },

  methods: {
    confirmDeleteUser(id) {
      this.deletedUsers.push(id);
      this.$mutate(this.$mutations.deleteUser, { id });
    },

    getOnlineStatusColor(isOnline) {
      return this.$CONSTANTS.onlineStatuses[+isOnline].color;
    },

    async updateUsers() {
      const { data } = await this.$query(this.$queries.appState);
      const users = get(data, 'currentUser.organization.users');

      if (users) {
        store.state.organization.users = users;
        this.fetchedUsers = users;
      }
    },
  },
};
</script>
